import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { StyledA, StyledAButton } from './styled';

const A = forwardRef((props, ref) => {
  const { href, isExternal, ...rest } = props;

  if (props.as === 'button') {
    return <StyledAButton as="button" {...rest} />;
  } else if (
    !isExternal &&
    (href.includes(location.hostname) ||
      (import.meta.env.DEV && href.includes('https://opossum.netlify.app')) ||
      Array.from(href)[0] === '/')
  ) {
    const to = Array.from(href)[0] === '/' ? href : new URL(href).pathname;

    return <StyledA as={Link} to={to} ref={ref} target="_self" {...rest} />;
  } else {
    return <StyledA href={href} ref={ref} {...rest} />;
  }
});

export default A;
